export default __webpack_public_path__ + "static/media/1_0112.9e0a71e5.webp";